import { Button, styled } from '@mui/material';

export const ButtonW = styled(Button)`
  font-weight: 400;
  font-size: 18px;
  line-height: 20px;
  height: 50px;
  text-transform: uppercase;
  width: 100%;
  border-radius: 12px;
  @media (max-width: 1023px) {
    margin: 48px auto;
  }
`;
